module.exports = __webpack_public_path__ + "static/media/audio-red.a9a38160.svg";